import { api } from '../../api.js';

export const assistantApi = {
    async chat(message) {
        return api.post('/assistant/chat', { message });
    },

    // Agentic deep-analysis mode: LLM tool_use loop over salon data.
    // Gated server-side by dashboard.view_finance.
    async analyze(message) {
        return api.post('/assistant/analyze', { message });
    },

    async history(page = 1, perPage = 50) {
        return api.getPaginated('/assistant/history', { page, per_page: perPage });
    },

    async prompt(messageId) {
        return api.post('/assistant/prompt', { message_id: messageId });
    },
};
